import {ProgressOverTimeMetric} from "./progressOverTimeMetric";

export class ProgressOverTimeFilter {
    public metric: ProgressOverTimeMetric;
    public isDeficitAvailable: boolean = false;
    public useDeficit: boolean = false;
}
